import Vue from 'vue'
import axios from './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueClipboard from 'vue-clipboard2'

Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(VueScrollTo, {
  easing: 'ease-out'
});

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

new Vue({
  created () {
      AOS.init()
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
